import { HttpClient } from '@store/base';
import _ from 'lodash';
import querystring from 'query-string';
import {
  GetGoodsDeliveryEstimatedDateRequest,
  GetGoodsDeliveryEstimatedDateResponse,
  GetGoodsDeliveryGuideRequest,
  GetGoodsDeliveryGuideResponse,
  GetGoodsDeliveryInfoRequest,
  GetGoodsDeliveryInfoResponse,
} from '../../model';

export class GetGoodsDeliveryGuideGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsDeliveryGuideRequest) {
    return await this.httpClient.request<GetGoodsDeliveryGuideResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/delivery/guide`,
    });
  }
}

export class GetGoodsDeliveryEstimatedDateGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsDeliveryEstimatedDateRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsDeliveryEstimatedDateResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/delivery/hanssem/estimated-date?${query}`,
      },
    );
  }
}

export class GetGoodsDeliveryInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsDeliveryInfoRequest) {
    return await this.httpClient.request<GetGoodsDeliveryInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/delivery`,
    });
  }
}
